module.exports = __webpack_public_path__ + "img/information_gray.a7d6c34d.svg";